import { FC } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Modal,
  Box,
  Typography,
  Button,
  Backdrop,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface AuthRequiredModalProps {
  open: boolean;
  onClose?: () => void;
  onLogin: () => void;
}

const AuthRequiredModal: FC<AuthRequiredModalProps> = ({
  open,
  onClose,
  onLogin,
}) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleClose = () => {
    onClose?.();
    if (pathname !== "/") navigate("/");
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
        sx: {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          backdropFilter: "blur(4px)",
        },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "90%",
          maxWidth: 400,
          bgcolor: "background.paper",
          borderRadius: 3,
          boxShadow: 24,
          p: 3,
          outline: "none",
        }}
      >
        <IconButton
          aria-label="Закрыть"
          onClick={handleClose}
          size="small"
          sx={{ position: "absolute", top: 8, right: 8, color: "text.secondary" }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>

        <Typography
          variant="h6"
          component="h2"
          sx={{
            fontWeight: 500,
            fontSize: 14,
            lineHeight: 1.4,
            color: "text.primary",
            mb: 1,
            pr: 4,
          }}
        >
          Вы не авторизованы
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontWeight: 400,
            fontSize: 16,
            lineHeight: 1.25,
            color: "#4D4D4D",
            mb: 1,
          }}
        >
          Для просмотра контента необходимо войти в свой аккаунт.
        </Typography>

        <Button
          fullWidth
          onClick={onLogin}
          sx={{
            backgroundColor: "#E9033A", // Красный цвет как на картинке
            borderRadius: "12px",
            py: "10px",
            px: "16px",
            fontWeight: 500,
            fontSize: 14,
            lineHeight: 1.5,
            color: "white",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "#C53030",
            },
          }}
        >
          Войти
        </Button>
      </Box>
    </Modal>
  );
};

export default AuthRequiredModal;
